export enum InspectionPlanStatus {
  Draft = 1,
  Active = 2,
  Historic = 3,
}
